import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Form, Modal, Row } from "antd";
import { Link, useHistory, useParams } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../../..";
import { TypesCharacteristicsCreateContext } from "../../context/TypesCharacteristicsCreateContext/TypesCharacteristicsCreateContext";
import { ITypesCharacteristicsCreateContext } from "../../context/TypesCharacteristicsCreateContext/types";
import { TypesCharacteristicsObjectParams } from "../../features/TypesCharacteristicsObjectParams/TypesCharacteristicsObjectParams";
import { TypesCharacteristicsObjectValues } from "../../features/TypesCharacteristicsObjectValues/TypesCharacteristicsObjectValues";
import "./TypesCharacteristicsObjectCreate.less";
import { ITypesCharacteristicsValuesTableRecord } from "../../features/TypesCharacteristicsObjectValues/utils/types";
import { ITypesCharacteristicsObjectCreateParams } from "../../types/TypesCharacteristicsObjectCreateParams";
import {
  checkIsLoading,
  toHttpFormat,
  toHttpFormatEndOfDay,
  toHttpFormatStartOfDay,
} from "../../../../lib/utils";
import {
  createTypesCharacteristicsObject,
  fetchTypesCharacteristicsSelectValueDic,
  searchTypesCharacteristics,
} from "../../store/slice/typesCharacteristicsSlice";
import { TypeCharacteristic } from "../../types/TypeCharacteristic";

export const TypesCharacteristicsObjectCreate = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { charTypeId } = useParams<{ charTypeId: string }>();

  const { createTypesCharacteristicsObjectLoading, typesCharacteristics } = useAppSelector(
    (state) => state.typesCharacteristicsObject
  );

  const [typesCharacteristicsObjectParamsForm] = Form.useForm();

  const contextValue: ITypesCharacteristicsCreateContext = {};

  const [selectedCharType, setSelectedCharType] = useState<TypeCharacteristic | undefined>(
    undefined
  );

  const onSelectedCharType = (charTypeId: number) => {
    const findedCharType = typesCharacteristics.find((item) => item.id === charTypeId);

    if (setSelectedCharType) {
      setSelectedCharType(findedCharType);
    }

    if (findedCharType && findedCharType?.valueDicTypeAlias) {
      dispatch(fetchTypesCharacteristicsSelectValueDic(findedCharType?.valueDicTypeAlias));
    }

    if (typesCharacteristicsObjectParamsForm) {
      typesCharacteristicsObjectParamsForm.setFieldsValue({
        defaultValue: undefined,
      });
    }
  };

  useEffect(() => {
    if (charTypeId) {
      dispatch(searchTypesCharacteristics({ charTypeIds: [charTypeId] })).then((res) => {
        if (Array.isArray(res.payload?.content) && res.payload?.content[0]) {
          setSelectedCharType(res.payload?.content[0]);
          typesCharacteristicsObjectParamsForm.setFieldsValue({
            charTypeId: Number(charTypeId),
          });
        }
      });
    }
  }, [charTypeId]);

  const [targetKeys, setTargetKeys] = useState<string[]>([]);

  const onFinish = (fields) => {
    const getFormatDefaultValue = () => {
      // Форматируем значение под тип данных
      const getFormatForDataTypeId = (defaultValue) => {
        switch (selectedCharType?.dataTypeId) {
          case 3:
            return defaultValue ? toHttpFormatStartOfDay(defaultValue) : undefined;
          default:
            return defaultValue;
        }
      };

      // Если есть значения, значит в defaultValue, должно быть оно или ничего
      if (selectedCharType?.charTypeValues && selectedCharType?.charTypeValues?.length > 0) {
        if (fields.defaultValue) {
          const findedCharTypeValue = selectedCharType.charTypeValues?.find(
            (item) => item.id === fields.defaultValue
          );

          if (findedCharTypeValue) {
            return getFormatForDataTypeId(findedCharTypeValue.value);
          }
        }
      }

      return getFormatForDataTypeId(fields.defaultValue);
    };

    const params: ITypesCharacteristicsObjectCreateParams = {
      charTypeId: Number(fields.charTypeId),
      objectTypeId: Number(fields.objectTypeId),
      name: fields.name,
      alias: fields?.alias,
      accessModeId: Number(fields.accessModeId),
      storageTypeId: Number(fields.storageTypeId),
      viewModeMask: Number(fields.viewModeMask),
      minCardinality: fields?.minCardinality !== undefined ? fields?.minCardinality : undefined,
      maxCardinality: fields?.maxCardinality !== undefined ? fields?.maxCardinality : undefined,
      defaultValue: getFormatDefaultValue(),
      fromDate: toHttpFormatStartOfDay(fields.fromDate),
      toDate: fields.toDate ? toHttpFormatEndOfDay(fields.toDate) : undefined,
    };

    if (targetKeys && targetKeys.length > 0) {
      params.objectCharTypeValues = targetKeys.map((key) => {
        return {
          fromDate: toHttpFormatStartOfDay(fields.fromDateValues),
          toDate: fields.toDateValues ? toHttpFormatStartOfDay(fields.toDateValues) : undefined,
          charTypeValueId: Number(key),
        };
      });
    }

    dispatch(
      createTypesCharacteristicsObject({
        objectTypeId: Number(fields.objectTypeId),
        params,
      })
    ).then((res) => {
      if (res?.payload?.id) {
        setTimeout(() => {
          typesCharacteristicsObjectParamsForm.resetFields();
          history.push(
            `/types-characteristics-object/${res?.payload?.objectTypeId}/${res?.payload?.id}?onDate=${res?.payload?.toDate}`
          );
        }, 1000);
      }
    });
  };

  return (
    <TypesCharacteristicsCreateContext.Provider value={contextValue}>
      <div className="types-characteristics-object-create">
        <Row className="types-characteristics-object-create-title" align="middle">
          <Link to="/types-characteristics-object">
            <LeftOutlined style={{ fontSize: 16 }} />
          </Link>

          <h1>Создание типа характеристики (объект)</h1>

          <Divider className="types-characteristics-object-create-divider" />
        </Row>

        <Form
          form={typesCharacteristicsObjectParamsForm}
          onFinish={onFinish}
          labelAlign="left"
          initialValues={{
            storageTypeId: 2,
            accessModeId: 2,
            viewModeMask: 8,
            fromDate: moment(),
            fromDateValues: moment(),
          }}
          style={{ width: "100%" }}
        >
          <TypesCharacteristicsObjectParams
            mode="create"
            typesCharacteristicsObjectParamsForm={typesCharacteristicsObjectParamsForm}
            selectedCharType={selectedCharType}
            onSelectedCharType={onSelectedCharType}
            targetKeys={targetKeys}
          />

          <Divider
            className="types-characteristics-object-create-divider"
            style={{ marginTop: "-10px", marginBottom: 0 }}
          />

          {selectedCharType && selectedCharType.charTypeValues?.length > 0 && (
            <TypesCharacteristicsObjectValues
              mode="create"
              typesCharacteristicsObjectParamsForm={typesCharacteristicsObjectParamsForm}
              selectedCharType={selectedCharType}
              targetKeys={targetKeys}
              setTargetKeys={setTargetKeys}
            />
          )}
        </Form>

        <Row align="middle" style={{ paddingTop: "10px" }} justify="center">
          <Col
            span={24}
            style={{
              textAlign: "center",
            }}
          >
            <Button
              style={{
                margin: "0 8px",
              }}
              onClick={() => {
                history.push(`/types-characteristics-object`);
                typesCharacteristicsObjectParamsForm.resetFields();
              }}
            >
              Отмена
            </Button>
            <Button
              type="primary"
              onClick={() => {
                typesCharacteristicsObjectParamsForm.submit();
              }}
              loading={checkIsLoading(createTypesCharacteristicsObjectLoading)}
            >
              Сохранить
            </Button>
          </Col>
        </Row>
      </div>
    </TypesCharacteristicsCreateContext.Provider>
  );
};
